/*
  Anchors Dawn's cart drawer under the header bag pill so capra.css can lay
  it out as a popover. The drawer's behaviour (open, close, focus trap,
  section re-rendering) is Dawn's, with one change in cart-drawer.js:
  renderContents() no longer opens the drawer after an add to cart, so an add
  only refreshes the header count and the drawer contents. This script
  measures the pill each time the drawer becomes active and exposes the
  result as two custom properties the stylesheet reads:

    --capra-cart-anchor-top    distance from the viewport top to the pill's
                               bottom edge
    --capra-cart-anchor-right  distance from the viewport right to the pill's
                               right edge

  When the pill is off screen (a header set to hide on scroll, or none at
  all) the properties are cleared so the CSS fallbacks place the panel under
  the sticky header instead.
*/
(() => {
  const drawer = document.querySelector('cart-drawer');
  const pill = document.getElementById('cart-icon-bubble');
  if (!drawer || !pill) return;

  const anchor = () => {
    const rect = pill.getBoundingClientRect();
    const onScreen = rect.width > 0 && rect.bottom > 0 && rect.top < window.innerHeight;

    if (!onScreen) {
      drawer.style.removeProperty('--capra-cart-anchor-top');
      drawer.style.removeProperty('--capra-cart-anchor-right');
      return;
    }

    drawer.style.setProperty('--capra-cart-anchor-top', `${Math.round(rect.bottom)}px`);
    drawer.style.setProperty('--capra-cart-anchor-right', `${Math.round(window.innerWidth - rect.right)}px`);
  };

  const isOpen = () => drawer.classList.contains('active');

  // Dawn toggles the `active` class from both the pill click and the
  // add-to-cart flow. Observing the class covers both without patching
  // CartDrawer.open. Observer callbacks run before the next paint, so the
  // panel never flashes at its fallback position.
  new MutationObserver(() => {
    if (isOpen()) anchor();
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', () => {
    if (isOpen()) anchor();
  });
})();
